import actions from "../../actions"
import {
	reConstructionMaterialPeriodPricesConstants
}from "./constants"

const initialState =
{
	isSending : false,
	changed   : null,
	paged     : {},
	error     : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reConstructionMaterialPeriodPricesConstants.GetPaged.REQUEST:
		case reConstructionMaterialPeriodPricesConstants.Upload.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reConstructionMaterialPeriodPricesConstants.GetPaged.FAILURE:
		case reConstructionMaterialPeriodPricesConstants.Upload.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}

		case reConstructionMaterialPeriodPricesConstants.Upload.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result
			}

		case reConstructionMaterialPeriodPricesConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}

		case (reConstructionMaterialPeriodPricesConstants.CLEAR):
			return {
				isSending : false,
				changed   : null,
				paged     : {},
				error     : null
			}

		default:
			return state
	}
}